var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group uk-margin"
  }, [(_vm.label) ? _c('label', {
    staticClass: "uk-form-label",
    class: {
      'uk-text-danger': this.isInvalid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onFocus($event)
      }
    }
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label) + " "), (_vm.required) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "uk-form-controls"
  }, [_vm._t("default"), _vm._v(" "), _c('validation-hint', {
    attrs: {
      "errors": _vm.errors
    }
  }), _vm._v(" "), _vm._t("hints")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-938bafa0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/FormGroup.vue
// module id = 2084
// module chunks = 0